import useSocialMediaAddForm from "./UseSocialMediaAddForm";

import Input from "@usas/ui-web/components/inputs/Input";
import Dropdown from "@usas/ui-web/components/dropdowns/Dropdown";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SocialMediaAddForm = ({ submitButtonText = 'Add Social Media', onSubmitFormCallback,
  onIsDirtyChanged = undefined, onErrorCaught = undefined }) => {
  const {
    socialMediaOptions,
    isDirty,
    formState,
    errorState,
    resetForm,
    handleSubmit,
    updateFormState,
    onValueTextPairChanged
  } = useSocialMediaAddForm(onSubmitFormCallback, onIsDirtyChanged, onErrorCaught);

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <Dropdown
            label="Social Media Platform"
            name="socialMediaTypeId"
            value={formState.socialMediaTypeId}
            error={errorState.socialMediaTypeId}
            message={errorState.socialMediaTypeId}
            isLoading={socialMediaOptions.length === 0}
            options={socialMediaOptions}
            onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, 'socialMediaTypeId', newValueLabel, 'socialMediaTypeName'); }}
          />
        </div>
        <div className='col-xs-12 col-sm-6'>
          <Input
            label="Handle / Username / Website"
            name="socialHandle"
            value={formState.socialHandle}
            error={errorState.socialHandle}
            message={errorState.socialHandle}
            onChange={(value) => { updateFormState('socialHandle', value); }} />
        </div>
      </div>
      {errorState.errorOnSubmitAction &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
          </div>
        </div>
      }
      {errorState.formError &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.formError || ''}</p>
          </div>
        </div>
      }
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <PrimaryButton type="submit" isDisabled={isDirty === false}>{submitButtonText}</PrimaryButton>&nbsp;
          {isDirty === true && <SecondaryButton type="button" onClick={resetForm}>Cancel</SecondaryButton>}
        </div>
      </div>
    </form>
  );
};

export default SocialMediaAddForm;